import { render, staticRenderFns } from "./UserCrud.vue?vue&type=template&id=1db72cfa&scoped=true"
import script from "./UserCrud.vue?vue&type=script&lang=js"
export * from "./UserCrud.vue?vue&type=script&lang=js"
import style0 from "./UserCrud.vue?vue&type=style&index=0&id=1db72cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db72cfa",
  null
  
)

export default component.exports